module.exports = __webpack_public_path__ + "static/media/psl-logo-new.fe66b00d.png";